import React, { Component } from 'react';
import { Form } from 'react-form';
import { Input } from '../Form';
import * as validate from '../../utils/form-validation';
import EmailChipArea from './EmailChipArea';

import styles from './bulkEmailInvite.scss';

class BulkEmailInvite extends Component {
    constructor(props) {
        super(props);
        this.state = {
            validEmails: [],
            invalidEmails: [],
            error: '',
            submitting: false,
        };
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handlePaste = this.handlePaste.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.addEmail = this.addEmail.bind(this);
        this.exposeFormApi = this.exposeFormApi.bind(this);
    }

    // componentDidMount() {
    //     const { initialValues } = this.props;
    //     console.log('BulkEmailInvite willmount props', this.props)
    //     if (initialValues) {
    //         this.setState({
    //             validEmails: initialValues,
    //         });
    //     }
    // }

    handleSubmit = () => {
        const { onSuccess } = this.props;
        const { validEmails } = this.state;

        if (validEmails.length > 500) {
            const error = 'A maximum of 500 emails is supported';
            this.formApi.setError('email', error);

            this.setState({
                error,
            });
        } else {
            this.setState({ submitting: true });
            if (onSuccess) {
                onSuccess(validEmails);
            }
        }
    };

    handleKeyDown = (value, evt) => {
        if (['Enter', 'Tab', ','].includes(evt.key)) {
            evt.preventDefault();
            this.addEmail(value);
        }
    };

    handlePaste = (_value, evt) => {
        evt.preventDefault();
        const paste = evt.clipboardData.getData('text');
        if (paste) {
            /*
                Split by all delimiters
                Take the first we find that results in multiple items
                If not, just send the pasted content as a single item array
                addEmails will attempt to valid each item in array
             */

            // Place character delimiters before space
            // otherwise, trailing spaces on characters will also cause spliting
            // This causes the character ends up as part of emails
            const delimiters = [',', ';', '\n', ' '];
            const attemptsToSplitPastedText = delimiters.map(delimiter => paste.split(delimiter));
            const firstListWithMultipleItems = attemptsToSplitPastedText.find(splitString => splitString.length > 1);
            const emails = firstListWithMultipleItems || [paste];

            if (emails.length > 0) { // TO-DO: this is always true.
                this.addEmails(emails);
            } else {
                const error = 'Could not determine delimiter, please use comma, space, or carriage returns';
                this.formApi.setError('email', error);
                this.setState({
                    error,
                });
            }
        }
    };

    handleDelete(email, valid) {
        if (valid) {
            const { validEmails, error } = this.state;
            const index = validEmails.indexOf(email);
            if (index > -1) {
                validEmails.splice(index, 1);
            }
            const updatedError = validEmails.length <= 500 ? '' : error;
            this.setState({
                validEmails,
                error: updatedError,
            });
            this.formApi.setError('email', updatedError);
        } else {
            const { invalidEmails, error } = this.state;
            const index = invalidEmails.indexOf(email);
            if (index > -1) {
                invalidEmails.splice(index, 1);
            }
            const updatedError = invalidEmails.length === 0 || !invalidEmails ? '' : error;
            this.setState({
                invalidEmails,
                error: updatedError,
            });
            this.formApi.setError('email', updatedError);
        }
    }

    addEmail(email) {
        if (email) {
            let error = '';
            const trimmedEmail = email?.toLowerCase().trim();
            const validation = validate.email(trimmedEmail);
            if (validation.error) {
                error = 'Please enter a valid email address';
                this.formApi.setError('email', error);
            } else {
                const { validEmails } = this.state;
                if (!validEmails.includes(trimmedEmail)) {
                    this.formApi.setValue('email', '');
                    this.setState({
                        validEmails: [...validEmails, trimmedEmail],
                    });
                }
            }
            this.setState({
                error,
            });
        }
    }

    addEmails(emailList) {
        const { validEmails, invalidEmails } = this.state;
        const validEmailsInList = [];
        const invalidEmailsInList = [];
        emailList.forEach((email) => {
            const trimmedEmail = email?.toLowerCase().trim();
            if (trimmedEmail) {
                const validation = validate.email(trimmedEmail);
                if (validation.error) {
                    if (!invalidEmails.includes(trimmedEmail)) {
                        invalidEmailsInList.push(trimmedEmail);
                    }
                } else if (!validEmails.includes(trimmedEmail)) {
                    validEmailsInList.push(trimmedEmail);
                }
            }
        });
        const error = invalidEmailsInList.length > 0 ? 'Please correct invalid emails' : '';
        this.formApi.setError('email', error);
        this.setState({
            invalidEmails: [...invalidEmails, ...invalidEmailsInList],
            validEmails: [...validEmails, ...validEmailsInList],
            error,
        });
    }

    exposeFormApi(formApi) {
        if (formApi) {
            this.formApi = formApi;
        }
    }

    render() {
        const { validEmails, invalidEmails, submitting, error } = this.state;
        const { className, 'data-testid': dataTestId } = this.props;
        const disabled = validEmails.length <= 0 || submitting || error;
        return (
            <div className={`${styles.component} ${className}`}>
                <EmailChipArea validEmails={validEmails} invalidEmails={invalidEmails} handleDelete={this.handleDelete} />
                <Form onSubmit={this.handleSubmit}>
                    {(formApi) => {
                        this.exposeFormApi(formApi);
                        return (
                            <form onSubmit={formApi.submitForm} id="bulkEmailForm" className="m0" data-testid={dataTestId && `${dataTestId}.form`}>
                                <div>
                                    <Input
                                        label="Email"
                                        hiddenLabel={true}
                                        field="email"
                                        placeholder="Type or paste email addresses, then hit 'Enter'"
                                        onKeyDown={this.handleKeyDown}
                                        onChange={this.handleChange}
                                        onPaste={this.handlePaste}
                                        disableProfanityCheck={true}
                                    />
                                </div>
                                <button disabled={disabled} type="submit" className="btn btn-primary btn-xl btn-block text-uppercase" data-testid={dataTestId && `${dataTestId}.submit-btn`}>
                                    {submitting ? 'Sending' : 'Send Invites'}
                                </button>
                            </form>
                        );
                    }}
                </Form>
            </div>
        );
    }
}

export default BulkEmailInvite;
